import { motion } from "framer-motion";
import { useStateValue } from "../../context/StateProvider";
import { useOrderAvailability } from "../../utils/schedule";

const CartTotal = ({ checkoutState }: { checkoutState: any }) => {
    const [{ cartTotal, cartItems }] = useStateValue();
    const { canOrder, isWorking, closingTime, todaySchedule } = useOrderAvailability();
    const DELIVERY_PRICE = 300;

    // Проверяем, можно ли оформлять заказ
    const isOrderAvailable = canOrder && cartItems.length > 0;

    // Формируем сообщение о недоступности заказов
    const getUnavailableMessage = () => {
        if (!todaySchedule) {
            return "Не удалось загрузить расписание";
        }

        if (cartItems.length === 0) {
            return "Корзина пуста";
        }

        if (!isWorking) {
            return `Ресторан закрыт. Открытие в ${todaySchedule.start}`;
        }

        if (!canOrder && isWorking) {
            return `Заказы не принимаются. Ресторан работает до ${closingTime}`;
        }

        return "";
    };

    const handleCheckout = () => {
        if (!isOrderAvailable) {
            return;
        }
        checkoutState(true);
    };

    const message = getUnavailableMessage();
    const showMessage = !isOrderAvailable && message;

    return (
        <div className="w-full mt-2 md:mt-0 rounded bg-cartItem px-8 py-2 flex flex-col items-center">
            <div className="w-full flex items-center justify-between">
                <p className="text-textColor md:text-lg uppercase">Доставка</p>
                <p className="text-textColor md:text-lg ">
                    <span className="text-sm text-buttonColor">P</span> {DELIVERY_PRICE}
                </p>
            </div>

            <div className="w-full flex items-center justify-between">
                <p className="text-textColor md:text-lg uppercase">Итого</p>
                <p className="text-textColor md:text-lg ">
                    <span className="text-sm text-buttonColor">P</span> {cartTotal}
                </p>
            </div>

            {/* Сообщение о недоступности заказов - до кнопки */}
            {showMessage && (
                <motion.div
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="w-full mb-2 p-2"
                >
                    <p className="text-textColor text-sm text-center font-medium">
                        {message}
                    </p>
                </motion.div>
            )}

            <motion.button
                onClick={handleCheckout}
                whileTap={isOrderAvailable ? { scale: 0.8 } : {}}
                className={`
                    w-full p-2 rounded-full text-lg my-2 
                    transition-all duration-200
                    ${isOrderAvailable
                    ? 'bg-gradient-to-tr from-buttonColor to-buttonColor text-gray-50 hover:shadow-lg cursor-pointer'
                    : 'bg-gray-300 text-gray-500 cursor-not-allowed opacity-70'
                }
                `}
                disabled={!isOrderAvailable}
            >
                {!isOrderAvailable ? 'Заказы не принимаются' : 'Оформить заказ'}
            </motion.button>
        </div>
    );
};

export default CartTotal;